import * as S from './index.style'
import Logo from 'assets/images/Logo.svg'

export const Header: React.FC = () => (
  <S.Wrapper>
    <img src={Logo} />
  </S.Wrapper>
)
